import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../../i18n";
import LanguageMenu from "../Sections/LanguageMenu";

export default function Header() {
  const location = useLocation();
  const { t } = useTranslation();
  const match = location.pathname.match(/^\/(en|de|it|es|pt)(\/|$)/);
  const langPrefix = match ? `/${match[1]}` : "";

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <nav className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link 
            to={`${langPrefix}/`} 
            className="flex items-center gap-3"
          >
            <img 
              src="/Logo_van-2-go.webp" 
              alt="Van-2-Go.ch" 
              className="h-10 w-auto"
            />
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to={`${langPrefix}/`}
              className="hidden sm:block px-4 py-2 text-sm font-semibold text-gray-700 hover:text-emerald-600"
            >
              {t("navigation.home")}
            </Link>
            <Link
              to={`${langPrefix}/reserver`}
              className="px-4 py-2 text-sm font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-700"
            >
              {t("navigation.book")}
            </Link>
            <LanguageMenu />
          </div>
        </div>
      </nav>
    </header>
  );
}
